import React, { useState } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Pencil } from "lucide-react";
import Modal from "react-bootstrap/Modal"; // Import Modal from react-bootstrap
import Button from "react-bootstrap/Button"; // Import Button from react-bootstrap

const insertmoduleoption = [
    {
        label: "Sales Management",
        options: [
            { value: "Sales_1", label: "Sales User" },
            { value: "Sales_2", label: "Sales Admin" },
        ],
    },
    {
        label: "Accounts Management",
        options: [
            { value: "Account_1", label: "Account User" },
            { value: "Account_2", label: "Account Admin" },
        ],
    },
];

const InsertModuleRole = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [tableData, setTableData] = useState([
        { value: "Sales", label: "Sales User" },
    ]);
    const [showInsertModule, setShowInsertModule] = useState(false);
    const [showSaveButton, setShowSaveButton] = useState(false);
    const [isPenIcon, setIsPenIcon] = useState(true);
    const [showDeleteModal, setShowDeleteModal] = useState(false); // State for modal visibility
    const [itemToDelete, setItemToDelete] = useState(null); // State to store the item to delete

    const handleChange = (selectedOption) => {
        setSelectedOption(null);
        if (!tableData.some((item) => item.value === selectedOption.value)) {
            setTableData([...tableData, selectedOption]);
            setShowSaveButton(true);
        }
    };

    const handleDeleteClick = (value) => {
        // Store the item to delete and show the modal
        setItemToDelete(value);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = () => {
        if (itemToDelete) {
            // Filter out the row with the matching value
            const updatedTableData = tableData.filter((item) => item.value !== itemToDelete);
            setTableData(updatedTableData);
            setShowSaveButton(true); // Enable save button after deletion
        }
        setShowDeleteModal(false); // Close the modal
        setItemToDelete(null); // Reset the item to delete
    };

    const handleSave = () => {
        console.log("Saved data:", tableData);
        alert("Module roles saved successfully!");
        setShowSaveButton(false);
    };

    const toggleIcon = () => {
        setShowInsertModule(!showInsertModule);
        setShowSaveButton(true);
        setIsPenIcon(!isPenIcon);
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card mb-3">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">Module Role</h5>
                        <div>
                            {showSaveButton && (
                                <button className="btn btn-primary btn-sm me-2" onClick={handleSave}>Save</button>
                            )}
                            <button className="border-0 bg-transparent" onClick={toggleIcon}>
                                {isPenIcon ? (
                                    <Pencil className="text-primary" size={20} />
                                ) : (
                                    <FontAwesomeIcon className="text-primary" icon={faTimes} size={20} />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={showInsertModule ? "col-lg-8" : "col-lg-12"}>
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className="mb-0">Module Role List</h6>
                    </div>
                    <div className="card-block">
                        <div className="table-responsive">
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Module</th>
                                        <th>Role</th>
                                        <th className="text-end">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((item, index) => (
                                        <tr key={item.value}>
                                            <td>{index + 1}</td>
                                            <td>{item.label.split(" ")[0]}</td>
                                            <td>{item.label}</td>
                                            <td align="right">
                                                <FontAwesomeIcon
                                                    className="text-danger cursor-pointer"
                                                    icon={faTrash}
                                                    onClick={() => handleDeleteClick(item.value)} // Pass the value to delete
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {showInsertModule && (
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-header">
                            <h6 className="mb-0">Insert Module Roles</h6>
                        </div>
                        <div className="card-block">
                            <Select
                                className="f-14"
                                options={insertmoduleoption}
                                value={selectedOption}
                                onChange={handleChange}
                                isSearchable
                                placeholder="Select Module..."
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            <Modal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                centered // This prop centers the modal
            >
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-dark">
                    Are you sure you want to delete this row?
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-danger btn-sm" variant="" onClick={() => setShowDeleteModal(false)}>
                        No
                    </Button>
                    <Button className="btn btn-primary btn-sm" variant="" onClick={handleDeleteConfirm}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default InsertModuleRole;